const DEFAULT_WS_PATH = "/api/v1/tickets/ws";

function getTicketsWsUrl() {
  const proto = window.location.protocol === "https:" ? "wss://" : "ws://";
  const hostname = window.location.hostname;
  const ticketsPort = import.meta.env.VITE_TICKETS_API_PORT || "8006";
  const useHost =
    hostname === "localhost" || hostname === "127.0.0.1"
      ? `${hostname}:${ticketsPort}`
      : window.location.host;
  return `${proto}${useHost}${DEFAULT_WS_PATH}`;
}

class TicketAiDraftWsService {
  constructor() {
    this.ws = null;
    this.callbacks = new Set();
    this.reconnectInterval = 3000;
    this.connecting = false;
  }

  subscribe(callback) {
    this.callbacks.add(callback);
    this._connect();
    return () => this.callbacks.delete(callback);
  }

  _connect() {
    if (
      this.ws &&
      (this.ws.readyState === WebSocket.OPEN ||
        this.ws.readyState === WebSocket.CONNECTING)
    ) {
      return;
    }
    if (this.connecting) {
      return;
    }

    this.connecting = true;
    try {
      const url = getTicketsWsUrl();
      this.ws = new WebSocket(url);
      this.ws.onopen = () => {
        this.connecting = false;
      };
      this.ws.onmessage = (event) => this._onMessage(event);
      this.ws.onclose = () => {
        this.connecting = false;
        setTimeout(() => this._connect(), this.reconnectInterval);
      };
      this.ws.onerror = () => {
        this.connecting = false;
        try {
          this.ws?.close();
        } catch {
          // ignore
        }
      };
    } catch {
      this.connecting = false;
      setTimeout(() => this._connect(), this.reconnectInterval);
    }
  }

  _onMessage(event) {
    let message;
    try {
      message =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    } catch {
      return;
    }

    if (message?.type !== "ai_draft_update" || !message.ticket_uuid) {
      return;
    }

    for (const callback of this.callbacks) {
      try {
        callback(message);
      } catch {
        // ignore subscriber errors
      }
    }
  }
}

const ticketAiDraftWsService = new TicketAiDraftWsService();
export default ticketAiDraftWsService;
